import { render, staticRenderFns } from "./OtherDeptFollow.vue?vue&type=template&id=af340356"
import script from "./OtherDeptFollow.vue?vue&type=script&lang=js"
export * from "./OtherDeptFollow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports